import * as React from "react";

import "./card-list.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";
import {chain} from "@Common/utils/fs";

import {CardLine}        from "./card-line/card-line";
import {DeleteCardModal} from "./delete-card-modal/delete-card-modal";

export const CardList = (
    {
        cards, onDeleteSavedCard, onDeleteNonceCard, selectedCards, multiple,
        getAssumedAmount=undefined,
        onSaveCardAmount=undefined,
        onEditNonceCard, onEditSavedCard,
        onDeselectSavedCard=undefined,
        onSelectSavedCard,
    }
) => cs(
    ["deleteCardModal", ({}, next) => DeleteCardModal({next})],

    ({deleteCardModal}) => (
        <div className="card-list card-list-02s">
            {!selectedCards?.length && !cards?.length && (
                <div className="no-data">
                    No credit card(s) available
                </div>
            )}

            {chain(
                selectedCards?.find((card) => card.type === "nonce"),
                (card) => card && (
                    CardLine({
                        card,
                        selected: true,
                        multiple,
                        getAssumedAmount,
                        onSaveCardAmount,
                        onSelect: () => deleteCardModal.show({
                            messageLines: [
                                "This card is not saved, so deselecting will remove it permanently.",
                                "Are you sure you want to proceed?"
                            ].filter(v=>v),
                            onYes: () => onDeleteNonceCard(card),
                        }),
                        onEdit: () => onEditNonceCard(card),
                        onDelete: () => deleteCardModal.show({
                            messageLines: [
                                "Are you sure you want to remove this unsaved card?",
                                cards.length == 1 && (
                                    "If so you will need to add another payment method to complete your order."
                                )
                            ].filter(v=>v),
                            onYes: () => onDeleteNonceCard(card),
                        }),
                    })
                ),
            )}

            {cards?.map((card, i) => {
                const selected = selectedCards?.find((c) => c.cardToken === card.cardToken);
                return cs(
                    keyed(i),
                    ({}) => CardLine({
                        card: {
                            ...card,
                            amount: selected?.amount,
                        },
                        selected,
                        multiple,
                        getAssumedAmount,
                        onSaveCardAmount,
                        onSelect: () => {
                            if (selected) {
                                if (multiple) {
                                    onDeselectSavedCard?.(card);
                                }
                            } else {
                                onSelectSavedCard(card);
                            }
                        },
                        onEdit: () => onEditSavedCard(card),
                        onDelete: () => deleteCardModal.show({
                            messageLines: [
                                "Are you sure you want to remove this credit card from your profile?",
                                cards.length == 1 && (
                                    "If so you will need to add another payment method to complete your order."
                                ),
                            ].filter(v=>v),
                            onYes: async () => onDeleteSavedCard(card)
                        }),
                    }),
                );
            })}
        </div>
    )
);
